<div id="main-container" class="d-flex w-100 h-100 justify-content-center align-items-center">
    <div class="card p-4 text-center">
        <h2 class="mb-3">Pago Vencido</h2>
        <p>Contacte con soporte para más información.</p>
    </div>
</div>